import { ReactNode } from 'react';
import { ExamType } from '../../api/exam';
import Segment from '../shared/segment';
import Field from '../shared/field';
import Section from '../shared/section';

export type ExamInfoPropsType = {
  exam: ExamType;
  children: ReactNode;
};

function ExamInfo({ exam, children }: ExamInfoPropsType) {
  return (
    <Segment hoverable noPad noMargin className='mx-3 flex flex-col sm:mx-auto sm:w-3/4 lg:w-2/3'>
      <Section textAlign='center' className='text-xl font-medium'>
        <span className='p-3'>{exam.name}</span>
      </Section>
      <Section className='flex flex-col gap-3'>
        <Field title='زمان آزمون' content={`${exam.duration} دقیقه`} />
        <Field title='تعداد سوالات' content={exam.questionCount} />
        <Field title='نمره منفی' content={exam.penalty ? 'دارد' : 'ندارد'} />
        <Field title='تعداد شرکت کنندگان تاکنون' content={`${exam.studentFinishedCount} نفر`} />
      </Section>
      {(exam.introduction || exam.description || exam.voice) && (
        <Section className='flex flex-col gap-4'>
          {exam.introduction && <Field title='معرفی' content={exam.introduction} />}
          {exam.description && <Field title='توضیحات' content={exam.description} />}
        </Section>
      )}
      <Section>
        <p className='font-black text-red-500'>توجه:</p>
        <p className='text-justify font-medium'>
          با توجه به اهمیت رتبه‌بندی علمی در آزمون‌ها و حفظ امنیت آزمون، فقط یک بار امکان شرکت در هر
          آزمون وجود دارد.
        </p>
        <p className='text-justify font-medium'>
          پس از شروع آزمون، در صورتی که به هر علتی از صفحه خارج شوید، فقط تا پایان زمان آزمون امکان
          بازگشت و ادامه آزمون را خواهید داشت و پس از آن فقط امکان مرور سوالات به همراه جواب تشریحی
          را خواهید داشت.
        </p>
        <p className='text-justify font-medium'>
          لطفا قبل از ورود به آزمون از پایدار بودن شرایط (از جمله وضعیت اینترنت، شارژ گوشی، وضعیت
          کشیک یا آنکالی و ...) مطمئن شوید.
        </p>
      </Section>
      <Section end>{children}</Section>
    </Segment>
  );
}

export default ExamInfo;
